<template>
  <el-drawer
    custom-class="el-drawer-deal el-drawer-credit  unaccreditInfo"
    :visible.sync="ifshow"
    size="840px"
    v-if="ifshow"
    @close="closeDrawer"
  >
    <div slot="title">
      <div class="flex_between">
        <div>
          <div>举报ID{{getByIdFullData.reportid}}</div>
          <div>
            <span class="vertical_middle">{{getByIdFullData.shop_name||getByIdFullData.shopname}}</span>
            <img
              :src="require('@/assets/img/platform/pla_'+getByIdFullData.platform_code+'.png')"
              alt
              class="edit_icon vertical_middle"
              v-if="getByIdFullData.platform_code"
            />
          </div>
        </div>
        <div>
          <i class="el-icon-success" v-show="getByIdFullData.result"></i>
          <img
            src="@/assets/img/other/await_icon.png"
            alt
            class="await_icon"
            v-show="!getByIdFullData.result"
          />
          <span>{{getByIdFullData.result != '0' ? '已处理' : '待处理'}}</span>
        </div>
      </div>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="举报信息处理" name="first">
        <commonReportInfo :data="getByIdFullData"></commonReportInfo>
        <div v-if="getByIdFullData.result&& !amendDeal">
          <el-row class="info_header">
            <el-col :span="22">
              <div class="drawer-subtitle_common margin_top10">
                <span class="drawer-subtitle-text">处理信息</span>
              </div>
            </el-col>
            <el-col :span="2">
              <!-- <el-link
                type="primary"
                :underline="false"
                v-if="getByIdFullData.result&&logintype=='KEFU'"
                @click="changeAmendDeal"
              >修改信息</el-link> -->
              <el-link
                type="primary"
                :underline="false"
                v-if="logintype=='KEFU'"
                @click="changeAmendDeal"
              >修改信息</el-link>
            </el-col>
          </el-row>
          <el-card class="margin_top_bottom20" v-if="getByIdFullData.result&&!amendDeal">
            <el-form :label-width="labelWidth">
              <el-form-item label="处理方式：">{{getByIdFullData.result}}</el-form-item>
              <el-form-item label="处理截图：">
                <viewer :images="getByIdFullData.handlepic">
                  <img
                    v-for="(item,index) in getByIdFullData.handlepic"
                    :src="item"
                    alt
                    :key="index"
                    style="width:100px;height:100px"
                  />
                </viewer>
              </el-form-item>
              <el-form-item label="处理说明：">{{getByIdFullData.decisions}}</el-form-item>
              <el-form-item label="处理人：">{{getByIdFullData.handle}}</el-form-item>
            </el-form>
          </el-card>
        </div>
        <!-- <div v-if="(!getByIdFullData.result||amendDeal)&&logintype=='KEFU'" style="padding:1px"> -->
        <div v-if="(!getByIdFullData.result||amendDeal)" style="padding:1px">
          <el-row class="info_header">
            <el-col :span="22">
              <div class="drawer-subtitle_common margin_top10">
                <span class="drawer-subtitle-text">处理信息</span>
              </div>
            </el-col>
          </el-row>
          <el-card class="margin_top_bottom20">
            <el-form :label-width="labelWidth" :model="deal" ref="ruleForm">
              <el-form-item label="处理结果：" :required="true">
                <el-select filterable v-model="deal.result" size="small" clearable  style="width:90%">
                  <el-option
                    v-for="(item,i) in dealResult"
                    :key="i+'a533'"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="处理截图：">
                <uploadPic @getpic="getpic" v-model="deal.handlepic" :imgList="deal.handlepic"></uploadPic>
              </el-form-item>
              <el-form-item label="处理说明：">
                <el-input
                  style="width:90%"
                  type="textarea"
                  placeholder="请输入说明，请保持在200字以内。"
                  maxlength="200"
                  class="check_textarea"
                  v-model="deal.decisions"
                ></el-input>
              </el-form-item>
            </el-form>
          </el-card>
          <div class="flex_end margin_top20">
            <el-button type="confire_btn" size="small" @click="updateStatus">确定</el-button>
            <el-button type="cancel_blue" size="small" @click="ifshow=false">取消</el-button>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="处理时间节点" name="second">
        <delFlowList :unCheck="unCheck"></delFlowList>
      </el-tab-pane>
    </el-tabs>
  </el-drawer>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import commonReportInfo from "@/views/CreditScore/common/commonReportInfo";
import dealTitle from "@/views/CreditScore/common/dealMainInfo/dealTitle";
import uploadPic from "@/views/CreditScore/common/uploadPic";
import { fetchPost } from "@/libs/reqCommon";
import { getLoginType } from "@/libs/until";
import delFlowList from "views/CreditScore/common/delFlowList";

export default {
  props: {
    reportid: {
      type: String
    }
  },
  data() {
    return {
      activeName: "first",
      ifshow: false,
      labelWidth: "100px",
      dealResultcheck: "",
      dealResult: ["通知店铺整改", "知识产权投诉", "已安排溯源"],
      stateName: "待处理",
      deal: {
        handlepic: [],
        result: "",
        decisions: ""
      },
      amendDeal: false,
      unCheck: [0, 2, 3, 4, 5, 6, 7, 8, 9, 12, 11],
      logintype: getLoginType()
    };
  },
  computed: {
    ...mapGetters(["getByIdFullData"])
  },
  components: { commonReportInfo, dealTitle, uploadPic, delFlowList },
  created() {},
  methods: {
    ...mapActions(["getById"]),
    closeDrawer() {
      this.deal.decisions = ''
      this.deal.result = ''
      this.deal.handlepic = []
      this.amendDeal = false;
      this.ifshow = false;
    },
    echoDeal() {
      let { result, decisions, handlepic, status } = this.getByIdFullData;
      if (result === "通知店铺整改" || result === "知识产权投诉" || result === "已安排溯源") {
        this.deal.result = result;
      }
      if (result) {
        this.deal.handlepic = handlepic;
        this.deal.decisions = decisions;
      }
      this.stateName = !result ? "待处理" : "已处理";
      this.amendDeal = !result ? true : false;
    },
    changeAmendDeal() {
      this.echoDeal();
      this.amendDeal = true;
    },
    getpic(imgList) {
      this.deal.handlepic = String(imgList);
    },
    async updateStatus() {
      if (!this.deal.result) {
        this.$message.error("请选择处理结果");
        return false;
      }
      this.deal.handlepic = String(this.deal.handlepic);
      fetchPost("/hcm/hcmReport/handleInstall", {
        ...this.deal,
        id: this.getByIdFullData.id
      })
        .then(res => {
          if (res.status === "10000") {
            this.$message.success("成功");
            this.$emit("loadList");
            this.ifshow = false;
          } else {
            this.$message.error(res.message);
          }
          this.deal.handlepic = [];
          this.deal.result = "";
          this.deal.decisions = "";
        })
        .catch(() => {
          this.$message.error("失败");
        });
    }
  }
};
</script>
<style lang="scss">
.unaccreditInfo {
  .el-tabs__header{
    margin-bottom: 0;
  }
  .drawer-subtitle_common {
    margin: 0;
  }
  .el-card {
    margin: 20px 0;
  }
  .check_textarea{
    .el-textarea__inner {
      height: 90px;
    }
  }
}
</style>
